import { ModuleDropdownProps } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

import { useAbility } from '~/app/contexts/AbilityContext';
import { Icon } from '~/shared/components';

const style = {
    color: '#191F2E',
    size: 16,
};

export function useModuleItems() {
    const { t } = useTranslate();
    const ability = useAbility();

    const items: ModuleDropdownProps['items'] = [
        {
            label: t('modules.my_compensation'),
            subtitle: t('menu.rewards'),
            icon: <Icon.MoneyBag color={style.color} size={style.size} />,
            url: 'https://rewards.ab-inbev.com/',
        },
        {
            label: t('modules.my_talent_card'),
            subtitle: t('menu.opr'),
            icon: <Icon.Badge color={style.color} size={style.size} />,
            url: 'https://opr.ab-inbev.com/talent-card/me',
        },
        {
            label: t('modules.my_targets'),
            subtitle: t('menu.northstar'),
            icon: <Icon.Target color={style.color} size={style.size} />,
            url: 'https://northstar.ab-inbev.com/',
        },
    ];

    if (ability.can('view', 'Cheershub')) {
        items.unshift({
            label: t('modules.cheershub'),
            subtitle: t('modules.cheershub'),
            icon: <Icon.Cheershub color={style.color} size={style.size} />,
            url: 'https://abinbevwwqa.service-now.com/cheers',
        });
    }

    return { items };
}
